var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.$t('analytics:filter:residentials')))]),_c('div',{attrs:{"data-part":"details"}},[_vm._l((_vm.filter),function(f){return [_c('div',[_vm._v(_vm._s(f.label)+":")]),_c('div',{attrs:{"data-part":"value"}},[_vm._v(_vm._s(f.formatted))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }